import { useMemo } from 'react'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { moneyString } from 'util/currency'
import { formatNumberWithSeparators } from 'util/numbers'

import { styles } from './styles'
import Product from './Product'

const ProductItem = ({
  name,
  image,
  sku,
  stock,
  currency,
  price,
  orderItems,
  variantId,
}) => {
  const alreadyAdded = useMemo(() => orderItems.find(i => i.id === variantId), [
    orderItems,
    variantId,
  ])
  return (
    <>
      <Product image={image} name={name} css={styles.product}>
        {sku}
      </Product>
      <span css={[styles.stock, alreadyAdded && text.styles.italic]}>
        {alreadyAdded
          ? 'Item already added'
          : `${formatNumberWithSeparators(stock)} in stock`}
      </span>
      <span>
        {moneyString({ amount: price * 100, currencyCode: currency })}
      </span>
    </>
  )
}

export default ProductItem
